import { EcrNote as EcrNoteType } from "api/memberPortal/ecr/notes/ecrNotes.types";
import { useAuth } from "hooks/useAuth";
import parse from "html-react-parser";
import Accordion from "react-bootstrap/Accordion";
import { standardDateTimeFormat } from "utils/timeUtils";

import { EcrNoteParams } from "./EcrNote.schema";

const EcrNote = ({
  note,
  openNoteModal,
  openDeleteModal,
  selectedNotes,
  setSelectedNotes,
}: EcrNoteParams) => {
  const { currentUser } = useAuth();

  const noteStatus = (note: EcrNoteType) => {
    if (note?.response_type === "ECR Cancelled") {
      return note?.response_type;
    } else if (note?.released) {
      return `Released to ${note?.response_type}`;
    } else {
      return `Not Released to ${note?.response_type}`;
    }
  };

  const visibilityText = (note: EcrNoteType) => {
    if (note.private) {
      return "Private";
    } else if (note.visible_to_labs && note.visible_to_validators) {
      return "Visible to Lab and Validators";
    } else if (note.visible_to_labs) {
      return "Visible to Labs";
    } else if (note.visible_to_validators) {
      return "Visible to Validators";
    } else {
      return "N/A";
    }
  };

  return (
    <>
      <div className="text-end mt-3 mx-3">
        <button
          className="btn btn-link d-inline-block py-1"
          style={{ minWidth: 10 }}
          onClick={() => openNoteModal(note)}
        >
          Reply
        </button>
        {note?.creator?.id === currentUser?.id && (
          <>
            <button
              className="btn btn-link d-inline-block py-1"
              style={{ minWidth: 10 }}
              onClick={() => {
                openNoteModal(null, note);
              }}
            >
              Edit
            </button>
            <button
              className="btn btn-link d-inline-block py-1"
              style={{ minWidth: 10 }}
              onClick={() => openDeleteModal(note)}
            >
              Delete
            </button>
          </>
        )}
      </div>
      <div className="border border-secondary p-4 ms-3 mt-0">
        <p className="text-end">
          Note by: {note.creator?.first_name} {note.creator?.last_name} <br />
          {standardDateTimeFormat(note.entrydate)}
          <br />
          {visibilityText(note) === "N/A" ? (
            <span>Note status: {noteStatus(note)}</span>
          ) : (
            <span>Visibility: {visibilityText(note)} </span>
          )}
        </p>
        <h6>{note.gist}</h6>
        <div>{note.note1 && parse(note.note1)}</div>
        {note.responses && note.responses.length > 0 && (
          <Accordion
            defaultActiveKey={`${note.upid}`}
            activeKey={selectedNotes}
            onSelect={() => {
              const uniqueNotes = new Set(selectedNotes);
              if (uniqueNotes.has(`${note.upid}`)) {
                uniqueNotes.delete(`${note.upid}`);
              } else {
                uniqueNotes.add(`${note.upid}`);
              }
              setSelectedNotes([...uniqueNotes]);
            }}
          >
            <Accordion.Item
              eventKey={
                selectedNotes.includes(`${note.upid}`) ? `${note.upid}` : ""
              }
            >
              <Accordion.Header>
                {note.responses.length} Responses
              </Accordion.Header>
              <Accordion.Body>
                {note.responses.map((response) => (
                  <div key={response.upid}>
                    <EcrNote
                      note={response}
                      openNoteModal={openNoteModal}
                      openDeleteModal={openDeleteModal}
                      selectedNotes={selectedNotes}
                      setSelectedNotes={setSelectedNotes}
                    />
                  </div>
                ))}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        )}
      </div>
    </>
  );
};

export default EcrNote;
